module.exports = __webpack_public_path__ + "img/image_ot-germany-hamburg_operators_1920px.3ca171ba.jpg";